import { SIGNUP } from "../configs/routes";
import api from "./api";

export const signup = async (body) => {
  const response = await api.post(SIGNUP, body);
  return response.data;
};
